import { render } from "./Cover.vue?vue&type=template&id=b30245e2"
import script from "./Cover.vue?vue&type=script&lang=js"
export * from "./Cover.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/configuration/Cover.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b30245e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b30245e2', __exports__)) {
    console.log('reload')
    api.reload('b30245e2', __exports__)
  }
  
  module.hot.accept("./Cover.vue?vue&type=template&id=b30245e2", () => {
    console.log('re-render')
    api.rerender('b30245e2', render)
  })

}


export default __exports__